import { combineReducers } from 'redux';
import vdp from './vdpRuns/vdpRunReducer';
import crowdGroup from './crowdGroup/reducer';
import kp from './keypoint/reducer';
import projApo from './projApollo/reducer';
import imgbbox from './imgbbox/reducer';
import ss from './semanticSgm/reducer';
import apoXmlCnt from './apolloXmlCount/reducer';
import wrk from './worker/reducer';
import { reducer as form } from 'redux-form';

import imgSegment from './imgSegment/reducer';
import bxc from './bellerophonXmlCount/reducer';
import gorgon from './gorgon/reducer'
import adm from './adm/reducer'
import cw from './crowdWorkers/reducer'
import generic from '@lesofi/phoenix-sdk-js/lib/admin/redux/generic/reducer'
import auth from '@lesofi/phoenix-sdk-js/lib/admin/redux/auth/reducer'
import td from '@lesofi/phoenix-sdk-js/lib/admin/redux/taskDists/reducer';

export default combineReducers({auth,vdp,crowdGroup,kp,projApo,imgbbox,ss,apoXmlCnt,wrk,form,td,imgSegment,bxc,gorgon,adm,generic,cw});


// WEBPACK FOOTER //
// ./src/redux/reducer.js